export default {
    trucksTooltip: 'Show in the transport search',
};
